var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.71 50.02"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.52 46.77a3.84 3.84 0 013.83-3.84H34a3.84 3.84 0 100-7.67 3.84 3.84 0 110-7.67h18.4A26.33 26.33 0 0037.79 0a3.63 3.63 0 01.08.73A3.85 3.85 0 0134 4.57h-3.81a3.84 3.84 0 100 7.67 3.84 3.84 0 110 7.67H12.93a3.84 3.84 0 110-7.67h.32a3.84 3.84 0 000-7.67H11A3.86 3.86 0 019 4a26.34 26.34 0 0015.32 46 3.83 3.83 0 01-1.8-3.25m-9.59-11.49H9.1a3.84 3.84 0 010-7.67h3.83a3.84 3.84 0 010 7.67",
    fill: "#999",
    "data-name": "Layer 1"
  }))));
}
export default SvgCountry;